
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Ug8x", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $67c012166b43ab0c$export$6503ec6e8aabbaf; }, function (v) { return $67c012166b43ab0c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $67c012166b43ab0c$export$f7ad0328861e2f03; }, function (v) { return $67c012166b43ab0c$export$f7ad0328861e2f03 = v; });
var $67c012166b43ab0c$export$6503ec6e8aabbaf;
var $67c012166b43ab0c$export$f7ad0328861e2f03;
"use strict";
var $67c012166b43ab0c$var$mapping = new Map();
function $67c012166b43ab0c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$67c012166b43ab0c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $67c012166b43ab0c$var$resolve(id) {
    var resolved = $67c012166b43ab0c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$67c012166b43ab0c$export$6503ec6e8aabbaf = $67c012166b43ab0c$var$register;
$67c012166b43ab0c$export$f7ad0328861e2f03 = $67c012166b43ab0c$var$resolve;

});

parcelRegister("92HC5", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $695621aa74b73e2a$export$bdfd709ae4826697; }, function (v) { return $695621aa74b73e2a$export$bdfd709ae4826697 = v; });
var $695621aa74b73e2a$export$bdfd709ae4826697;
var $695621aa74b73e2a$export$c9e73fbda7da57b6;
var $695621aa74b73e2a$export$5a759dc7a1cfb72a;
"use strict";
var $695621aa74b73e2a$var$bundleURL = {};
function $695621aa74b73e2a$var$getBundleURLCached(id) {
    var value = $695621aa74b73e2a$var$bundleURL[id];
    if (!value) {
        value = $695621aa74b73e2a$var$getBundleURL();
        $695621aa74b73e2a$var$bundleURL[id] = value;
    }
    return value;
}
function $695621aa74b73e2a$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $695621aa74b73e2a$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $695621aa74b73e2a$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $695621aa74b73e2a$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$695621aa74b73e2a$export$bdfd709ae4826697 = $695621aa74b73e2a$var$getBundleURLCached;
$695621aa74b73e2a$export$c9e73fbda7da57b6 = $695621aa74b73e2a$var$getBaseURL;
$695621aa74b73e2a$export$5a759dc7a1cfb72a = $695621aa74b73e2a$var$getOrigin;

});

parcelRegister("bhORg", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("2KGnI"))
]).then(()=>parcelRequire("lxZ1n"));

});
parcelRegister("jmEuB", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("epnDT", function(module, exports) {
"use strict";
var $a7d5bd68ac71a390$var$cachedBundles = {};
var $a7d5bd68ac71a390$var$cachedPreloads = {};
var $a7d5bd68ac71a390$var$cachedPrefetches = {};
function $a7d5bd68ac71a390$var$getCache(type) {
    switch(type){
        case "preload":
            return $a7d5bd68ac71a390$var$cachedPreloads;
        case "prefetch":
            return $a7d5bd68ac71a390$var$cachedPrefetches;
        default:
            return $a7d5bd68ac71a390$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7d5bd68ac71a390$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("eSvpC", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("2rZFb"))
]).then(()=>parcelRequire("gU6ka"));

});

parcelRegister("1nhQ1", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("bMcTR"))
]).then(()=>parcelRequire("hOAOE"));

});

parcelRegister("3lCWx", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("hMKCS"))
]).then(()=>parcelRequire("c6z2K"));

});

parcelRegister("6KZQJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("gXq7s"))
]).then(()=>parcelRequire("d7nkV"));

});

parcelRegister("1Iz2b", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("7WQJb")).then(()=>parcelRequire("iKqsm"));

});

parcelRegister("isFqD", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("kNEm5")).then(()=>parcelRequire("gxLwv"));

});

parcelRegister("eEJZE", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dNaE1")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("23zpV"))
]).then(()=>parcelRequire("kXac5"));

});

parcelRegister("h1LnJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dNaE1")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("178jE"))
]).then(()=>parcelRequire("6wxEl"));

});

parcelRegister("i5JLD", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("jrb3C"))
]).then(()=>parcelRequire("iskSB"));

});

parcelRegister("03d8T", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4EyUB"))
]).then(()=>parcelRequire("1mAy2"));

});

parcelRegister("c7t64", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("a3EQG"))
]).then(()=>parcelRequire("9PAFx"));

});

parcelRegister("j11tX", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9RLsK"))
]).then(()=>parcelRequire("5JrKe"));

});

parcelRegister("fzaoZ", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("lg8Up")).then(()=>parcelRequire("hNd0W"));

});

parcelRegister("huSJT", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dNaE1")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("GRqh4"))
]).then(()=>parcelRequire("9oO9R"));

});

parcelRegister("iq87O", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9pN13")).then(()=>parcelRequire("h1CeD"));

});

parcelRegister("2CD3M", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("2NhwR"))
]).then(()=>parcelRequire("7JQiV"));

});

parcelRegister("1H3WK", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("aR6ba")).then(()=>parcelRequire("5DmW5"));

});

parcelRegister("5o4yo", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("bAAXO")).then(()=>parcelRequire("bQSqB"));

});

parcelRegister("4WF5p", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("3YWyp"))
]).then(()=>parcelRequire("5l7l5"));

});

parcelRegister("3H8Zn", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8oqvn"))
]).then(()=>parcelRequire("1qPDV"));

});

parcelRegister("74ibV", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("3omNN")).then(()=>parcelRequire("gvfIi"));

});

var $486a8fa1dde690d7$exports = {};


(parcelRequire("8Ug8x")).register((parcelRequire("92HC5")).getBundleURL("g63Tr"), JSON.parse('["g63Tr","as-modern.js","2KGnI","copyIban.module.9147e781.js","4PHEE","copyIban.module.19a332dd.js","2rZFb","flyoutMenu.module.f3a5eb1e.js","bMcTR","flyoutSearch.module.1fe1b9f1.js","hMKCS","formHeaderSearch.module.7372083b.js","gXq7s","magnificPopup.module.800cc54c.js","7WQJb","mainTextMore.module.4189599a.js","kNEm5","map.module.82b9154a.js","23zpV","modal.module.2f8a0f13.js","dNaE1","modal.module.5a9acf77.js","178jE","panel.module.a16dd0a2.js","jrb3C","swiper1.module.051ab5a0.js","9O12P","swiper1.module.b9ee7026.js","4EyUB","swiper2.module.102b6e39.js","a3EQG","swiper21.module.b5213af0.js","9RLsK","swiper11.module.3eae074d.js","lg8Up","teamsFilter.module.97d71e0d.js","GRqh4","tooltip.module.13269ac5.js","9pN13","contactSearch.module.5b957423.js","2NhwR","newsListView.module.15050464.js","aR6ba","donation.module.cd4ee0d3.js","bAAXO","donationProgress.module.e8c0fca0.js","3YWyp","donationSticky.module.11210450.js","8oqvn","asVideo.module.49e31400.js","3omNN","twingle.module.0c2c2921.js"]'));

"use strict";
function $25865e9d3dfe9009$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $25865e9d3dfe9009$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $25865e9d3dfe9009$var$_typeof(o);
}
function $25865e9d3dfe9009$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($25865e9d3dfe9009$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $25865e9d3dfe9009$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $25865e9d3dfe9009$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $25865e9d3dfe9009$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}

if (document.querySelector(".ctype-ce_contact_search")) Promise.resolve().then(function() {
    return (parcelRequire("iq87O"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector('[data-func="copy-iban"]')) Promise.resolve().then(function() {
    return (parcelRequire("bhORg"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".donation-func")) Promise.resolve().then(function() {
    return (parcelRequire("1H3WK"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".ctype-ce_donation_progress")) Promise.resolve().then(function() {
    return (parcelRequire("5o4yo"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".sticky-donation")) Promise.resolve().then(function() {
    return (parcelRequire("4WF5p"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".flyout-menu")) Promise.resolve().then(function() {
    return (parcelRequire("eSvpC"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".flyout-search")) Promise.resolve().then(function() {
    return (parcelRequire("1nhQ1"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".form-header-search")) Promise.resolve().then(function() {
    return (parcelRequire("3lCWx"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".lightbox")) Promise.resolve().then(function() {
    return (parcelRequire("6KZQJ"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector('[data-js="main-text-more"]')) Promise.resolve().then(function() {
    return (parcelRequire("1Iz2b"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".interactive-map")) Promise.resolve().then(function() {
    return (parcelRequire("isFqD"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".modal")) Promise.resolve().then(function() {
    return (parcelRequire("eEJZE"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".news-list-view,.news-search-result")) Promise.resolve().then(function() {
    return (parcelRequire("2CD3M"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".panel")) Promise.resolve().then(function() {
    return (parcelRequire("h1LnJ"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--1")) Promise.resolve().then(function() {
    return (parcelRequire("i5JLD"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--2")) Promise.resolve().then(function() {
    return (parcelRequire("03d8T"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--21")) Promise.resolve().then(function() {
    return (parcelRequire("c7t64"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--11")) Promise.resolve().then(function() {
    return (parcelRequire("j11tX"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".teams-filter")) Promise.resolve().then(function() {
    return (parcelRequire("fzaoZ"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector('[data-bs-toggle="tooltip"]')) Promise.resolve().then(function() {
    return (parcelRequire("huSJT"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector('[id^="twingle-public-embed-"]')) Promise.resolve().then(function() {
    return (parcelRequire("74ibV"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".js-player")) Promise.resolve().then(function() {
    return (parcelRequire("3H8Zn"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});
// =============================================================
// OTHER
// =============================================================
var $25865e9d3dfe9009$var$updateHeaderHeight = function updateHeaderHeight() {
    var headerHeight = document.querySelector("header").offsetHeight;
    document.querySelector("main").style.marginTop = headerHeight + "px";
};
$25865e9d3dfe9009$var$updateHeaderHeight();
var $25865e9d3dfe9009$var$checkUrlParams = function checkUrlParams() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("total") && urlParams.has("consumption") && urlParams.has("food") && urlParams.has("living_hs") && urlParams.has("living_pt") && urlParams.has("mobility") && urlParams.has("public_consumption") && !urlParams.has("tw_amount")) {
        var tw_amount = 0;
        var total = urlParams.get("total");
        tw_amount = parseFloat(total) / 1000 * 22;
        urlParams.set("tw_amount", tw_amount);
        window.history.replaceState({}, "", "".concat(location.pathname, "?").concat(urlParams));
        window.location.reload();
    }
};
$25865e9d3dfe9009$var$checkUrlParams();
var $25865e9d3dfe9009$var$attempts = 0;
var $25865e9d3dfe9009$var$_whenComplete = function whenComplete() {
    if ($25865e9d3dfe9009$var$attempts > 30) return;
    $25865e9d3dfe9009$var$attempts += 1;
    if (document.readyState === "complete") {
        var intervalId = setInterval(function() {
            $25865e9d3dfe9009$var$updateHeaderHeight();
        }, 50);
        window.onbeforeunload = function() {
            clearInterval(intervalId);
        };
    } else setTimeout(function() {
        $25865e9d3dfe9009$var$_whenComplete();
    }, 400);
};
$25865e9d3dfe9009$var$_whenComplete();
// =============================================================
// STYLES COMPLETE
// =============================================================
var $25865e9d3dfe9009$var$styleAttempts = 0;
var $25865e9d3dfe9009$var$_stylesComplete = function stylesComplete() {
    if ($25865e9d3dfe9009$var$styleAttempts > 30) return;
    $25865e9d3dfe9009$var$styleAttempts += 1;
    if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") document.querySelector("#sess").remove();
    else setTimeout(function() {
        $25865e9d3dfe9009$var$_stylesComplete();
    }, 300);
};
$25865e9d3dfe9009$var$_stylesComplete();


//# sourceMappingURL=as-modern.js.map
